import { LineChartComponent } from './../charts/line/line.component';
import { LineChartDirective } from './../charts/line/line.directive';
import { curry } from 'ramda/es';
import {
  Component,
  OnInit,
  OnChanges,
  ViewChild,
  Input,
  ComponentFactoryResolver
} from '@angular/core';
import { StatsService } from '../stats.service';
import * as humanize from 'humanize-duration';
import { Line } from '../charts/line/line';

import {
  getConcurrentUsersOptions,
  getViewsFilteredOptionCumulativeOption,
  getViewsFilteredOptions,
  bestUsersOptions,
  getVisitsOptions
} from './chartOptions';
import { TranslateService } from '@ngx-translate/core';

interface IDashboard {
  sessionId: number;
}

@Component({
  selector: 'stats-dashboard',
  templateUrl: `./dashboard.component.html`,
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnChanges, IDashboard {
  @Input() sessionId: number;
  @ViewChild(LineChartDirective) lineChartHost: LineChartDirective;
  filters = ['day', 'hour', 'month'];
  bestUsersUrl: Function;
  bestUsersOptions = bestUsersOptions;
  visitsUsersUrl: Function;
  visitsUsersOptions = getVisitsOptions;
  viewsFilteredUrl: Function;
  viewsFilteredOption = getViewsFilteredOptions;
  viewsFilteredOptionCumulative = getViewsFilteredOptionCumulativeOption;
  allUsersMergedUrl: Function;
  getConcurrentUsersUrl: Function;
  options: any[];
  panels: any[];
  activeChart: 0;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private statsService: StatsService,
    private translate: TranslateService
  ) {
    // use curry to pass translate as param, other params will be set
    // by LineChartComponent
    this.bestUsersOptions = curry(bestUsersOptions)(translate);
    this.visitsUsersOptions = curry(getVisitsOptions)(translate);
    this.viewsFilteredOption = curry(getViewsFilteredOptions)(translate);
    this.viewsFilteredOptionCumulative = curry(getViewsFilteredOptionCumulativeOption)(translate);
  }

  ngOnInit() {
    this.initDashboard();
  }

  ngOnChanges() {
    this.initDashboard();
  }

  private initDashboard() {
    this.bestUsersUrl = this.statsService.getBestUsersUrl;
    this.visitsUsersUrl = this.statsService.getBestVisitsUrl;
    this.viewsFilteredUrl = this.statsService.getStatsMergedByUrl;
    this.allUsersMergedUrl = this.statsService.getAllUsersMergedUrl;
    this.getConcurrentUsersUrl = this.statsService.getConcurrentUsersUrl;
    this.options = [
      {
        url: this.viewsFilteredUrl,
        sessionId: this.sessionId,
        options: this.viewsFilteredOption,
        filters: this.filters,
        filter: 'hour'
      },
      {
        url: this.viewsFilteredUrl,
        sessionId: this.sessionId,
        options: this.viewsFilteredOptionCumulative,
        filters: this.filters,
        filter: 'hour'
      },
      {
        url: this.getConcurrentUsersUrl,
        sessionId: this.sessionId,
        options: getConcurrentUsersOptions,
        filters: this.filters,
        filter: false
      }
    ];
    const defaultFormat = text => text;
    const meanFormat = minutes => {
      return humanize(minutes * 60 * 1000, {
        language: this.translate.currentLang.slice(0, 2),
        round: true
      });
    };

    this.panels = [
      {
        name: this.translate.instant('stats.total_hits'),
        url: this.statsService.getHitsTotalUrl,
        format: defaultFormat
      },
      {
        name: this.translate.instant('stats.time_users'),
        url: this.statsService.getTimeSpentMeanUrl,
        format: meanFormat
      },
      {
        name: this.translate.instant('stats.nb_users'),
        url: this.statsService.getDistinctHitsUrl,
        format: defaultFormat
      }
    ];
    this.setActive(0);
  }

  setActive(id) {
    this.activeChart = id;
    const options = this.options[id];
    const defaultView = new Line(
      LineChartComponent,
      options.url,
      options.options,
      options.sessionId,
      options.filters,
      options.filter
    );
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      defaultView.component
    );
    const viewContainerRef = this.lineChartHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<Line>componentRef.instance).url = options.url;
    (<Line>componentRef.instance).options = options.options;
    (<Line>componentRef.instance).sessionId = options.sessionId;
    (<Line>componentRef.instance).filters = options.filters;
    (<Line>componentRef.instance).filter = options.filter;
  }
  getActiveColor(id) {
    if (id === this.activeChart) {
      return 'white';
    }
    return 'rgba(255,255,255,0.54)';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/stats/dashboard/dashboard.component.ts